import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as _ from 'lodash';

import { Config } from 'shared/config/env.config';
import { contentHeaders } from 'common/headers';
import { SearchService } from 'shared/search/search.service';
import { SearchModel } from 'shared/search/search.model';
import { SortModel } from 'shared/search/sort.model';
import {catchError, map} from 'rxjs/operators';


@Injectable()
export class ExportManagerSearchService extends SearchService {

  // extendable fields:
  searchModel: SearchModel = new SearchModel();

  // implemented
  runSearch(brandId: string, searchModel: SearchModel, ...args: any[]): Observable<any> {
    /*
     *  If there is no sortModel set it to default
     */
    if (!searchModel.sortModel) {
      searchModel.sortModel = new SortModel();
      searchModel.sortModel.column = 'created_at';
      searchModel.sortModel.sort = 'desc';
    }
    // exports for certain receiver - receiverId passed in args
    const receiverId = args && args.length ? args[0] : null;

    const status: string = (searchModel.statusModel) ? searchModel.statusModel.id.toString() : '';
    const searchUri = `/exports/${brandId}`;
    let searchQueryString: string = this.getQueryString(searchModel);
    if (receiverId) {
      searchQueryString = `${searchQueryString}&receiverId=${receiverId}`;
    }
    return this.http.get(`${Config.API}${searchUri}?${searchQueryString}`)
      .pipe(map((res: any) => {
        this.updateData(res);
        return res;
      }),
      catchError(this.handleError.bind(this)));

  }

  // implemented
  updateData(data: any) {
    this.searchResults = data.data;
    this.totalRecords = data.total;
    this.searchModel.currentPage = data.current_page;
    this.searchModel.lastPage = data.last_page;
    this.searchModel.searchId = _.get(data, 'id', null);
  }

  getQueryString(searchModel: SearchModel): string {
    const sortCol: string = (searchModel.sortModel) ? searchModel.sortModel.column : '';
    const sortDir: string = (searchModel.sortModel) ? searchModel.sortModel.sort : '';
    const queryString: string =
      'page=' + searchModel.currentPage +
      '&itemsPerPage=' + searchModel.itemsPerPage +
      '&search=' + searchModel.searchValue +
      '&sortCol=' + sortCol +
      '&sortDir=' + sortDir;

    return queryString;
  }
}
